import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { DefaultIcon } from '../default-icon';
import type { TIconBlockDesktop, IDepsDesktop } from '../models';
import styles from '../styles.css';

import { IconBlockDesktop as Component } from './icon-block';

export const IconBlockDesktop = createWidget<IDepsDesktop, TIconBlockDesktop>({
    Block,
    DefaultIcon,
    styles,
})(Component);
